(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization-form"] && !Shopify.designMode) return;
  try {
    (function () {
    function initLangPickers() {
      document.querySelectorAll('[data-lang-picker]').forEach(function (picker) {
        var btn = picker.querySelector('[data-lang-picker-btn]');
        var list = picker.querySelector('[data-lang-picker-list]');
        var input = picker.querySelector('[data-lang-picker-input]');
        var form = picker.closest('form');

        if (!btn || !list || !input || !form) return;

        function openList() {
          list.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }

        function closeList() {
          list.hidden = true;
          btn.setAttribute('aria-expanded', 'false');
        }

        btn.addEventListener('click', function () {
          list.hidden ? openList() : closeList();
        });

        list.querySelectorAll('[data-lang-code]').forEach(function (item) {
          item.addEventListener('click', function () {
            input.value = item.dataset.langCode;
            form.submit();
          });

          item.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              input.value = item.dataset.langCode;
              form.submit();
            }
          });
        });

        document.addEventListener('click', function (e) {
          if (!picker.contains(e.target)) closeList();
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeList();
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLangPickers);
    } else {
      initLangPickers();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
